module.exports = __webpack_public_path__ + "static/media/LeagueBot_logo_transparent.665b26be.png";